// src/components/VoiceWidget.jsx - Hybrid EL Voice + n8n Text
import React, { useState, useEffect, useRef } from 'react';
import { useConversation } from '@elevenlabs/react';
import { 
  Button, 
  Input,
  Typography, 
  Space, 
  message,
  notification
} from 'antd';
import {
  PhoneOutlined,
  PhoneFilled,
  UpOutlined,
  DownOutlined,
  LoadingOutlined,
  SendOutlined,
  WifiOutlined,
  MessageOutlined,
  AudioOutlined,
  ToolOutlined
} from '@ant-design/icons';
import VoiceAnimation from './voiceAnimation'
import AgreementModal from './AgreementModal';

const { Text } = Typography;
  const onlyPhone = true
  const onlyText = false
const VoiceWidget = () => {

const [agreeActive, setAgreeActive] = useState(true);
const [showAgreementModal, setShowAgreementModal] = useState(false);

  const [agentSpeaking, setAgentSpeaking] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [messages, setMessages] = useState([]);
  const [inputText, setInputText] = useState('');
  const [useWebRTC, setUseWebRTC] = useState(true);
  const [isTextMode, setIsTextMode] = useState( onlyText ? true : false);
  const [isTyping, setIsTyping] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
const [agreeText] = useState("Las conversaciones de voz son procesadas en tiempo real sin retención de datos ni PII, conforme al RGPD.");
  // n8n API state
  const [sessionId, setSessionId] = useState(null);
  const [threadId, setThreadId] = useState(null);
  const assistantId = 'agent_01jz1rke3ve2jb3efgt7x7z2mr'; // Replace with your assistant ID
  const textAccumulatorRef = useRef('');
  const retryCountRef = useRef(0);

  // n8n Configuration
  const N8N_WEBHOOK_URL = 'https://15afb62b-a5f6-4553-93fc-aea728ca8346.clouding.host/webhook/b3829184-666f-4120-9eec-mieses';
const handleAgree = () => {
  setShowAgreementModal(false);
  setAgreeActive(false);
  startConversation(); // Continue with the original flow
};

const handleCancel = () => {
  setShowAgreementModal(false);
  // Don't start conversation
};
  // Initialize session ID on component mount
  useEffect(() => {
    if (!sessionId) {
      const newSessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      setSessionId(newSessionId);
      console.log('Generated session ID:', newSessionId);
    }
  }, []);
  const conversation = useConversation({
    onConnect: () => {
      addMessage('system', '🎉 ¡Conectado modo voz! Comienza a hablar...');
      messageApi.success('¡Conectado al Asistente de Voz!');
    },
    
    onDisconnect: () => {
      addMessage('system', '👋 Conversación de voz terminada');
      messageApi.info('Conversación terminada');
    },
    
onMessage: (msg) => {
  console.log('💬 ElevenLabs message received:', msg);
  
  switch (msg.type) {
    case 'user_transcript':
      if (msg.transcript && !isTextMode) {
        addMessage('user', msg.transcript);
      }
      break;
      
    case 'agent_response':
      if (msg.text && !isTextMode) {
        addMessage('agent', msg.text);
        setAgentSpeaking(true); // Agent started responding
      }
      break;
      
    case 'agent_response_complete': // If this event exists
      setAgentSpeaking(false);
      break;
      
    default:
      console.log('🔍 Unknown ElevenLabs message type:', msg.type);
  }
},
    
    onError: (error) => {
      console.error('❌ ElevenLabs error:', error);
      let errorMsg = '⚠️ Error de conexión de voz';
      
      if (error.message.includes('microphone')) {
        errorMsg = '🎤 Por favor permite acceso al micrófono';
        messageApi.error('Se requiere acceso al micrófono');
      } else if (error.message.includes('agent')) {
        errorMsg = '🤖 Verifica tu Agent ID en el código';
        messageApi.error('Error de configuración del agente');
      }
      
      addMessage('system', errorMsg);
    }
  });

useEffect(() => {
  // Detect when agent stops speaking
  if (agentSpeaking && !conversation.isSpeaking) {
    console.log('Agent finished speaking');
    setAgentSpeaking(false);
  } else if (!agentSpeaking && conversation.isSpeaking) {
    console.log('Agent started speaking');
    setAgentSpeaking(true);
  }
}, [conversation.isSpeaking, agentSpeaking]);
  const addMessage = (sender, content, isTyping = false) => {
    setMessages(prev => [...prev, {
      id: Date.now() + Math.random(),
      sender,
      content,
      timestamp: new Date(),
      isTyping
    }]);
  };

  // 📝 N8N TEXT MESSAGE HANDLER
  const sendTextToN8N = async (message) => {
    if (!sessionId) {
      messageApi.error('Session ID not available');
      return;
    }
    
    try {
      setIsLoading(true);
      
      // Clear accumulators
      textAccumulatorRef.current = '';
      retryCountRef.current = 0;
      
      // Add user message immediately
      const newUserMessage = {
        id: Date.now(),
        sender: 'user',
        content: message,
        timestamp: new Date(),
      };
      setMessages(prev => [...prev, newUserMessage]);
      
      // Create request body
      const requestBody = {
        session_id: sessionId,
        assistant_id: assistantId,
        message: message ,
        thread_id: threadId || null,
      };
      
      console.log('Sending to n8n:', requestBody);
      
      // Create assistant response placeholder with typing indicator
      const responseMessage = {
        id: Date.now() + 1,
        sender: 'agent',
        content: '',
        timestamp: new Date(),
        isTyping: true
      };
      setMessages(prev => [...prev, responseMessage]);
      
      // Send to n8n webhook
      const response = await fetch(N8N_WEBHOOK_URL, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        credentials: 'omit',
        body: JSON.stringify(requestBody)
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      console.log('n8n response:', data);
      
      // Process response
      if (data && data.output) {
        const messageText = data.output;
        
        // Clean response text
        const cleanedResponse = cleanResponseText(messageText);
        
        // Apply typewriter effect
        typewriterEffect(cleanedResponse, () => {
          setIsLoading(false);
        });
        
        // Update thread_id if provided
        if (data.thread_id) {
          setThreadId(data.thread_id);
        }
        
      } else {
        throw new Error('No output received from n8n');
      }
      
    } catch (error) {
      console.error('Error sending message to n8n:', error);
      messageApi.error(`Error: ${error.message}`);
      
      // Update the placeholder message with error
      setMessages(prev => {
        const newMessages = [...prev];
        const lastMessage = newMessages[newMessages.length - 1];
        if (lastMessage.sender === 'agent' && lastMessage.isTyping) {
          lastMessage.content = '❌ Error al procesar el mensaje. Intenta de nuevo.';
          lastMessage.isTyping = false;
        }
        return newMessages;
      });
      
      setIsLoading(false);
    }
  };

  // Clean response text (remove navigation commands, etc.)
  const cleanResponseText = (text) => {
    // Add your cleaning logic here
    return text.replace(/\[NAVIGATION:.*?\]/g, '').trim();
  };

  // Typewriter effect
  const typewriterEffect = (text, callback) => {
    let currentIndex = 0;
    const typingSpeed = 30; // milliseconds per character
    
    const typeNextChar = () => {
      if (currentIndex <= text.length) {
        const partialText = text.substring(0, currentIndex);
        
        setMessages(prev => {
          const newMessages = [...prev];
          const lastMessage = newMessages[newMessages.length - 1];
          if (lastMessage.sender === 'agent') {
            lastMessage.content = partialText;
            lastMessage.isTyping = currentIndex < text.length;
          }
          return newMessages;
        });
        
        currentIndex++;
        
        if (currentIndex <= text.length) {
          setTimeout(typeNextChar, typingSpeed);
        } else if (callback) {
          callback();
        }
      }
    };
    
    typeNextChar();
  };

  const checkMicrophonePermission = async () => {
    if (isTextMode) return true;
    
    try {
      await navigator.mediaDevices.getUserMedia({ audio: true });
      return true;
    } catch (error) {
      messageApi.error('Acceso al micrófono denegado. Cambiando a modo texto.');
      addMessage('system', '🚫 Acceso al micrófono denegado - usando modo texto');
      if (!onlyPhone) {

      setIsTextMode(true);
      }
      return true;
    }
  };

const startConversation = async () => {
  // Check if agreement is required and not yet given
   if (agreeActive) {
    setShowAgreementModal(true); // Show custom modal instead of window.confirm
    return; // Wait for modal response
  }

  if (isTextMode) {
    // Text mode - just show ready message
    addMessage('system', '💬 Modo texto listo ');
    messageApi.success('¡Modo texto activado!');
    return;
  }

  // Voice mode - use 
  const permitted = await checkMicrophonePermission();
  if (!permitted) return;

  try {
    const conversationId = await conversation.startSession({
      agentId: assistantId,
      connectionType: useWebRTC && isWebRTCSupported() ? 'webrtc' : 'websocket',
      userId: `user-${Date.now()}`,
      overrides: {
        agent: {
          language: 'es'
        }
      }
    });
    
    console.log('🆔 EL conversation started:', conversationId);
    
  } catch (error) {
    console.error('Failed to start conversation:', error);
    addMessage('system', `❌ Error al conectar: ${error.message}`);
    messageApi.error(`Conexión fallida: ${error.message}`);
  }
};

const endConversation = () => {
    if (!isTextMode && conversation.status === 'connected') {
      conversation.endSession();
    }
    setMessages([]);
    setInputText('');
    setIsTyping(false);
    setIsLoading(false);
    
    // Reset n8n session
    const newSessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    setSessionId(newSessionId);
    setThreadId(null);
  };

  // Enhanced text message sending
  const sendTextMessage = async () => {
    if (!inputText.trim()) return;
    
    const messageContent = inputText.trim();
    setInputText('');
    setIsTyping(false);
    
    if (isTextMode) {
      // Use n8n API for text mode
      await sendTextToN8N(messageContent);
    } else {
      // Use EL for voice mode (if connected)
      if (conversation.status === 'connected') {
        addMessage('user', messageContent);
        // EL SDK should handle text messages automatically
        messageApi.info('Mensaje enviado a EL...');
      } else {
        messageApi.warning('Conecta primero para enviar mensajes de texto');
      }
    }
  };

  const handleInputChange = (e) => {
    setInputText(e.target.value);
    
    if (e.target.value.trim() && !isTyping) {
      setIsTyping(true);
    } else if (!e.target.value.trim() && isTyping) {
      setIsTyping(false);
    }
  };

  const toggleMode = () => {
    const newMode = !isTextMode;
    if (onlyText || onlyPhone) {
return
    }
    setIsTextMode(newMode);
    
    if (newMode) {
      // Switching to text mode
      messageApi.info('📝 Modo texto activado ');
      addMessage('system', '📝 Cambiado a modo texto ');
      
      // Disconnect EL if connected
      if (conversation.status === 'connected') {
        conversation.endSession();
      }
    } else {
      // Switching to voice mode
      messageApi.info('🎤 Modo voz activado ');
      addMessage('system', '🎤 Cambiado a modo voz');
    }
  };

  const isWebRTCSupported = () => {
    return typeof RTCPeerConnection !== 'undefined';
  };

  // Auto-scroll messages
  useEffect(() => {
    const container = document.getElementById('messages-container');
    if (container) {
      container.scrollTop = container.scrollHeight;
    }
  }, [messages]);

  // Widget styles (keeping same design)
  const widgetContainerStyle = {
    position: 'fixed',
    bottom: '16px',
    right: '16px',
    zIndex: 1000,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
  };

  const compactWidgetStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '8px',
    borderRadius: '16px',
    background: 'white',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
    border: '1px solid #e5e7eb',
    pointerEvents: 'auto',
    overflow: 'hidden',
    width: isExpanded ? '320px' : 'auto',
    transition: 'all 0.2s ease'
  };

  const expandedWidgetStyle = {
    ...compactWidgetStyle,
    height: isTextMode ? '450px' : 'auto',
    marginBottom: '16px'
  };

  const avatarContainerStyle = {
    position: 'relative',
    width: '36px',
    height: '36px',
    flexShrink: 0
  };

  const avatarBorderStyle = {
    position: 'absolute',
    inset: '0',
    borderRadius: '50%',
    background: '#e5e7eb'
  };

  const avatarImageStyle = {
    position: 'absolute',
    inset: '0',
    borderRadius: '50%',
    overflow: 'hidden',
    backgroundImage: `url("https://storage.googleapis.com/eleven-public-cdn/convai/agent_01jz1rke3ve2jb3efgt7x7z2mr/avatar.png")`,
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  };

  const callButtonStyle = {
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '18px',
    fontSize: '14px',
    fontWeight: '500',
    transition: 'all 0.2s ease',
    border: 'none',
    cursor: 'pointer',
    overflow: 'hidden',
    userSelect: 'none',
    width: '100%',
    margin: '4px',
    zIndex: 1
  };

  const getCallButtonStyle = () => {
    if (isTextMode) {
      return {
        ...callButtonStyle,
        background: isLoading ? '#f59e0b' : '#1890ff',
        color: 'white',
        border: `1px solid ${isLoading ? '#d97706' : '#1677ff'}`
      };
    }
    
    if (conversation.status === 'connected') {
      return {
        ...callButtonStyle,
        background: '#ef4444',
        color: 'white',
        border: '1px solid #dc2626'
      };
    } else if (conversation.status === 'connecting') {
      return {
        ...callButtonStyle,
        background: '#f59e0b',
        color: 'white',
        border: '1px solid #d97706'
      };
    } else {
      return {
        ...callButtonStyle,
        background: '#1f2937',
        color: 'white',
        border: '1px solid #374151'
      };
    }
  };

  const messagesContainerStyle = {
    height: '200px',
    overflowY: 'auto',
    padding: '12px',
    background: '#f9fafb',
    display: isTextMode ? 'block': 'none'
  };

  const messageStyle = (sender) => ({
    display: 'flex',
    justifyContent: sender === 'user' ? 'flex-end' : sender === 'system' ? 'center' : 'flex-start',
    marginBottom: '8px'
  });

  const messageBubbleStyle = (sender) => ({
    maxWidth: '80%',
    padding: sender === 'system' ? '4px 8px' : '8px 12px',
    borderRadius: sender === 'system' ? '12px' : '12px',
    fontSize: sender === 'system' ? '11px' : '13px',
    backgroundColor: 
      sender === 'user' ? '#1890ff' :
      sender === 'system' ? '#f0f0f0' : '#ffffff',
    color: sender === 'user' ? 'white' : '#333',
    border: sender === 'agent' ? '1px solid #e5e7eb' : 'none',
    borderBottomRightRadius: sender === 'user' ? '4px' : undefined,
    borderBottomLeftRadius: sender === 'agent' ? '4px' : undefined
  });

  return (
    <div style={widgetContainerStyle}>
      {contextHolder}
      
      {isExpanded ? (
        // Expanded Widget
        <div style={expandedWidgetStyle}>
          {/* Header with Avatar and Title */}
          <div style={{ display: 'flex', alignItems: 'center', padding: '4px', gap: '8px', minWidth: '240px' }}>
            <div style={avatarContainerStyle}>
              <div style={avatarBorderStyle}></div>
              <div style={avatarImageStyle}></div>
            </div>
            <div style={{ position: 'relative', fontSize: '14px', maxWidth: '180px', flex: 1 }}>
              <span style={{ display: 'block', transition: 'transform, opacity 0.2s',fontSize: '10px', fontWeight: '500' }}>
                Habla con nuestro Agente Vocal 
              </span>
              <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '2px' }}>
                {isTextMode ? (
                  <>
                   
                  </>
                ) : (
                  <>
                    {conversation.status === 'connected' && '🟢 Voz Conectada'}
                    {conversation.status === 'connecting' && '🟡 Conectando...'}
                    {conversation.status === 'disconnected' && '⚫ Voz Desconectada'}
                    {conversation.isSpeaking && ' • 🗣️ IA Hablando'}
                  </>
                )}
              </div>
            </div>
            
            {/* Mode Toggle and Indicators */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>

              <Button
                type="text"
                size="small"
                icon={isTextMode ? <MessageOutlined /> : <AudioOutlined />}
                onClick={toggleMode}
                disabled={conversation.status === 'connecting' || isLoading || onlyPhone || onlyText}
                style={{
                  color: isTextMode ? '#1890ff' : '#52c41a',
                  border: 'none',
                  padding: '2px 4px',
                  display:  onlyText || onlyPhone ? 'none': 'block'

                }}
                title={isTextMode ? 'Cambiar a modo voz' : 'Cambiar a modo texto'}
              />
              
              {/* API Indicator */}
              <div style={{ 
                background: isTextMode ? '#1890ff' : '#52c41a',
                color: 'white',
                padding: '2px 6px',
                borderRadius: '8px',
                fontSize: '9px',
                display: onlyText || onlyPhone ? 'none': 'flex',
                alignItems: 'center',
                gap: '2px'
              }}>
               {isTextMode && !onlyPhone && !onlyText ? (
  <>
    <ToolOutlined style={{ fontSize: '8px' }} />
    Modo Texto
  </>
) : !onlyText && !onlyPhone ? (
  <>
    <WifiOutlined style={{ fontSize: '8px' }} />
    Modo Llamada
  </>
) : null}
              </div>
            </div>
          </div>

          {/* Messages */}
{!isTextMode && conversation.status !== 'disconnected' && <VoiceAnimation 
  status={conversation.status}   
  isSpeaking={agentSpeaking} // Use your state instead of conversation.isSpeaking
  isListening={conversation.status === 'connected' && !agentSpeaking}
/>}
          <div id="messages-container" style={messagesContainerStyle}>
            {messages.length === 0 && (
              <div style={{ textAlign: 'center', padding: '40px 20px', color: '#6b7280' }}>
                <div style={{ fontSize: '32px', marginBottom: '12px' }}>
                  {isTextMode ? '💬' : '🎤'}
                </div>
                <div style={{ fontWeight: '500', marginBottom: '4px' }}>
                  {isTextMode ? 'Modo texto' : 'Modo voz'}
                </div>
                <div >
                

                      </div>
              </div>
            )}
            
            {messages.map((msg) => (
              <div key={msg.id} style={messageStyle(msg.sender)}>
                <div style={messageBubbleStyle(msg.sender)}>
                  {msg.content}
                  {msg.isTyping && (
                    <span style={{ opacity: 0.7 }}>
                      <span style={{ animation: 'blink 1s infinite' }}>|</span>
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>

          {/* Enhanced Input Area */}
          <div style={{ display: isTextMode?'block':'none',top: '33px',
  position: 'relative',  padding: '8px', background: 'white', borderTop: '1px solid #e5e7eb' }}>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <Input
                placeholder={isTextMode ? "Dinos algo sobre ti..." : "Dinos algo sobre ti..."}
                value={inputText}
                onChange={handleInputChange}
                onPressEnter={sendTextMessage}
                disabled={isLoading || (!isTextMode && conversation.status !== 'connected')}
                style={{ flex: 1 }}
                suffix={
                  isTextMode ? (
                    <MessageOutlined style={{ color: '#1890ff' }} />
                  ) : (
                    <AudioOutlined style={{ color: '#52c41a' }} />
                  )
                }
              />
              <Button
                type="primary"
                icon={isLoading ? <LoadingOutlined spin /> : <SendOutlined />}
                onClick={sendTextMessage}
                disabled={isLoading || !inputText.trim() || (!isTextMode && conversation.status !== 'connected')}
                style={{ flexShrink: 0 }}
              />
            </div>
          </div>

          {/* Call Control Button */}
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <button
              type="button"
              aria-label={
                isTextMode ? 
                  (isLoading ? 'PROCESANDO...' : 'CHAT LISTA') :
                  (conversation.status === 'connected' ? 'TERMINAR LLAMADA' : 'LLAMADA GRATUITA')
              }
              style={getCallButtonStyle()}
              onClick={
                isTextMode ? 
                  () => {} : // Text mode doesn't need connection button
                  (conversation.status === 'connected' ? endConversation : startConversation)
              }
              disabled={conversation.status === 'connecting' || isLoading}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                {isTextMode ? (
                  <>
                    {isLoading ? (
                      <LoadingOutlined spin style={{ fontSize: '16px' }} />
                    ) : (
                      <MessageOutlined style={{ fontSize: '16px' }} />
                    )}
                    <span style={{ fontWeight: '500' }}>
                      {isLoading ? 'PROCESANDO...' : 'CHAT n8n LISTO'}
                    </span>
                  </>
                ) : (
                  <>
                    {conversation.status === 'connecting' ? (
                      <LoadingOutlined spin style={{ fontSize: '16px' }} />
                    ) : conversation.status === 'connected' ? (
                      <PhoneFilled style={{ fontSize: '16px' }} />
                    ) : (
                      <PhoneOutlined style={{ fontSize: '16px' }} />
                    )}
                    <span style={{ fontWeight: '500' }}>
                      {conversation.status === 'connecting' 
                        ? 'CONECTANDO...' 
                        : conversation.status === 'connected' 
                          ? 'TERMINAR LLAMADA' 
                          : 'LLAMADA GRATUITA'
                      }
                    </span>
                  </>
                )}
              </div>
            </button>
              <Button
                type="text"
                size="small"
                icon={isTextMode ? <AudioOutlined  style={{padding: 2, fontSize: 22}}/> : <MessageOutlined style={{padding: 2, fontSize: 22}} />}
                onClick={toggleMode}
                disabled={conversation.status === 'connecting' || isLoading}
                style={{
                  color: isTextMode ? '#1890ff' : '#52c41a',
                  border: 'none',
                  padding: '2px 4px',
                  display:  onlyText || onlyPhone ? 'none': 'block'

                }}
                title={isTextMode ? 'Cambiar a modo voz (EL)' : 'Cambiar a modo texto (n8n)'}
              />
          </div>
        </div>
      ) : (
        // Compact Widget
        <div style={compactWidgetStyle}>
          <div style={{ display: 'flex', alignItems: 'center', padding: '4px', gap: '8px', minWidth: '240px' }}>
            <div style={avatarContainerStyle}>
              <div style={avatarBorderStyle}></div>
              <div style={avatarImageStyle}></div>
            </div>
            <div style={{ position: 'relative', fontSize: '14px', maxWidth: '256px' }}>
              <span style={{ display: 'block', transition: 'transform, opacity 0.2s' }}>
                Habla con nuestra Asistente
              </span>
            </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center' }}>
            <button
              type="button"
              aria-label="INICIAR ASISTENTE"
              style={getCallButtonStyle()}
              onClick={() => setIsExpanded(true)}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <PhoneOutlined style={{ fontSize: '16px' }} />
                <span style={{ fontWeight: '500' }}>{onlyText? 'CHATEA' : onlyPhone ? 'LLAMA' : 'LLAMA / CHATEA'}    </span>
              </div>
            </button>

          </div>
      <p style={{padding: 1, margin: 0, fontSize: 9, textAlign: 'right'}}> Tecnología de <a href="https://synapsishub.es">Synapsis Hub</a> </p>

        </div>
      )}

      {/* Toggle Button */}
      {isExpanded && (
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button
            onClick={() => setIsExpanded(false)}
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              background: '#1f2937',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
            }}
          >
            <DownOutlined style={{ fontSize: '16px' }} />
          </button>
        </div>
      )}
      
      <style jsx>{`
        @keyframes blink {
          0%, 50% { opacity: 1; }
          51%, 100% { opacity: 0; }
        }
      `}</style>
<AgreementModal
  isVisible={showAgreementModal}
  onAgree={handleAgree}
  onCancel={handleCancel}
  agreementText={agreeText}
/>
    </div>
  );
};

export default VoiceWidget;